import { useTranslation } from "react-i18next";

import { faArrowLeft } from "@fortawesome/pro-regular-svg-icons";

import { useLocation, useNavigate } from "react-router-dom";

import { Icon } from "@/components";
import { ROUTE_CONFIG } from "@/routes/config";

import HighlightText from "@/components/HighlightText/HighlightText";

import FormContainer from "../../components/FormContainer";

export default function CheckYourEmail() {
	const { t } = useTranslation();
	const ts = (key: string) => t(`login.check-email.${key}`);
	const navigate = useNavigate();
	const location = useLocation();
	const state = location.state;

	return (
		<div className="w-full h-full flex flex-col relative items-center justify-center">
			<FormContainer
				changeActionsDirection
				actionContainerClassName="flex gap-2 !space-y-0"
				formContainerClassName="h-fit mt-16 mb-36"
				handleSubmit={() => navigate(ROUTE_CONFIG.LOGIN)}
				isLoading={false}
				secondaryButtonType="button"
				showLogo={false}
				submitButtonText={
					<>
						<Icon className="mr-2" icon={faArrowLeft} sx={{ width: "12px", height: "12px" }} />
						{ts("back-to-login")}
					</>
				}
				submitButtonType="button"
				title={ts("title")}
			>
				<HighlightText
					className="text-[14px] mt-4 text-primary-gray-lighter"
					highlights={[`${state?.email ?? "olivia@untitledui.com"}`]}
					text={ts("description") + `${state?.email ?? "olivia@untitledui.com"}`}
				/>
			</FormContainer>
		</div>
	);
}
